<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import utils from '@/util'

// constants
import OpenAIConstants from '@/constant/openAI'

// components
import UploadImageV2 from '@/components/presentations/UploadImage.v2.vue'

export default {
  extends: UploadImageV2,
  props: {
    slideOption: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      keyword: null,
    }
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,

    }),
    ...mapState('imageKeywordSuggestions', ['applyKeyword']),

    purpose() {
      const typeToPurposeMap = {
        slideImage: OpenAIConstants.AI_KEYWORD_QUESTION_IMAGE_PURPOSE,
        optionImage: OpenAIConstants.AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE,
        slideBackgroundImage: OpenAIConstants.AI_KEYWORD_BACKGROUND_PURPOSE,
        contentSlideImage: OpenAIConstants.AI_KEYWORD_CONTENT_PURPOSE,
      }

      return typeToPurposeMap[this.type] || false
    },

    hasSlideTitleWithNoQuestionImage() {
      const hasQuestionImage = this.slideActive && this.slideActive.image && this.slideActive.image.thumbnail
      const hasSlideTitle = this.slideActive && this.slideActive.title && this.slideActive.title.length > 0

      return !hasQuestionImage && hasSlideTitle
    },

    hasSlideOptionTitleWithNoSlideOptionImage() {
      const hasImage = this.slideOption && this.slideOption.imageCropped
      const hasTitle = this.slideOption && this.slideOption.title && this.slideOption.title.length > 0

      return !hasImage && hasTitle
    },

    isQuestionImagePurpose() {
      return this.purpose === OpenAIConstants.AI_KEYWORD_QUESTION_IMAGE_PURPOSE
    },

    isSlideOptionImagePurpose() {
      return this.purpose === OpenAIConstants.AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE
    },

    needAISearchKeywordSuggestion() {
      if (this.isQuestionImagePurpose) {
        return this.hasSlideTitleWithNoQuestionImage
      }
      if (this.isSlideOptionImagePurpose) {
        return this.hasSlideOptionTitleWithNoSlideOptionImage
      }
      return true
    },
  },
  watch: {
    applyKeyword() {
      this.keyword = this.applyKeyword
      this.updateKeywordAndTriggerImageSearch()
    },
  },
  async mounted() {
    if (!this.needAISearchKeywordSuggestion) return

    this.keyword = await this.getAISuggestedKeywordByPurposeAction({
      purpose: this.purpose,
      slideOption: this.slideOption,
    }) || ''

    if (!this.text?.length) {
      this.updateKeywordAndTriggerImageSearch()
    }
    this.fetchKeywords({
      purpose: this.purpose,
      slideOption: this.slideOption,
    })
  },

  methods: {
    ...mapActions('keyword', ['getAISuggestedKeywordByPurposeAction']),
    ...mapActions('imageKeywordSuggestions', ['fetchKeywords']),

    handleUploadImageCallback(fileLocation, type, file) {
      this.$emit('handleUploadImageForm', fileLocation, type, file)
    },

    handleMyPhotoSelectExistImage(obj) {
      this.$emit('selectExistImage', obj)
    },

    async updateKeywordAndTriggerImageSearch() {
      try {
        this.text = this.keyword
        this.searchPhotoUnsplash(1, false)
        if (this.selectedTab === this.ActiveTabNames.GIPHY) {
          await utils.sleep(500)
          this.previousSearchText = null // Reset to prevent debounce conflicts from multiple search calls
          this.giphyPhotos = []
          this.searchPhotoGiphy()
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
}
</script>
